var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_pagin"},[_c('el-pagination',{attrs:{"background":"","layout":"total, prev, pager, next","current-page":_vm.page,"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.getData,"update:currentPage":function($event){_vm.page=$event},"update:current-page":function($event){_vm.page=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }